import React, { useContext } from "react";
import {
  ConnectionContext,
  CONNECTION_STATUS,
} from "../../context/Connection/ConnectionContext";
import { AuthContext } from "../../context/Auth/AuthContext";

const ConnectionStatusBanner = () => {
  const {
    connectionStatus,
    reconnectAttempts,
    lastDisconnectedAt,
    isDisconnected,
    isReconnecting,
  } = useContext(ConnectionContext);

  const { socket } = useContext(AuthContext);

  const handleForceReconnect = () => {
    if (socket && typeof socket.forceReconnect === "function") {
      socket.forceReconnect();
    }
  };

  if (connectionStatus === CONNECTION_STATUS.CONNECTED) {
    return null;
  }

  const isReconnectingState = connectionStatus === CONNECTION_STATUS.RECONNECTING;

  return (
    <div
      className={`
        fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-4 py-2 text-sm font-medium transition-all duration-300
        ${
          isDisconnected
            ? "bg-red-600 text-white"
            : "bg-amber-500 text-white"
        }
      `}
    >
      <div className="flex items-center gap-2">
        <span
          className={`
            inline-block w-2 h-2 rounded-full
            ${isDisconnected ? "bg-red-300 animate-pulse" : "bg-amber-300 animate-pulse"}
          `}
        />
        <span>
          {isDisconnected
            ? "Conexão perdida"
            : `Reconectando... (tentativa ${reconnectAttempts})`}
        </span>
        {lastDisconnectedAt && (
          <span className="text-xs opacity-75">
            {new Date(lastDisconnectedAt).toLocaleTimeString("pt-BR")}
          </span>
        )}
      </div>

      {isDisconnected && (
        <button
          onClick={handleForceReconnect}
          className="ml-4 px-3 py-1 text-xs font-semibold bg-white text-red-600 rounded hover:bg-red-50 transition-colors"
        >
          Tentar reconectar
        </button>
      )}
    </div>
  );
};

export default ConnectionStatusBanner;
